// @flow
import React from 'react';
import { SvgXml } from 'react-native-svg';
import {
    Platform,
} from 'react-native';

const styles = {
    fill_white: {
        fill: '#fff',
    },
    first: {
        fill: '#bfcd31',
    },

};

type Props = {
    width?: number,
    height?: number,
}

const xml = `<svg xmlns="http://www.w3.org/2000/svg" width={120} height={120} viewBox="0 0 157.11 100.23">
                <title>device</title>
                <g id="Layer_2">
                    <g id="Layer_1-2">
                        <path
                            d="M31.7,99.71a2.55,2.55,0,1,1,0-5.09h93.7a2.55,2.55,0,1,1,0,5.09Z"
                            style="fill:#bfcd31"
                        />
                        <path
                            d="M125.4,95.13a2,2,0,1,1,0,4.07H31.7a2,2,0,1,1,0-4.07h93.7m0-1H31.7a3.07,
                            3.07,0,1,0,0,6.13h93.7a3.07,3.07,0,1,0,0-6.13Z"
                            style="fill:#fff"
                        />
                        <path
                            d="M19.76,90.05A19.06,19.06,0,0,1,.52,71.22V19.34A19.05,19.05,
                        0,0,1,19.76.52H137.35a19.05,19.05,0,0,1,19.24,18.82V71.22a19.06,
                        19.06,0,0,1-19.24,18.83Z"
                            style="fill:#bfcd31"
                        />
                        <path
                            d="M137.35,1a18.53,18.53,0,0,1,18.73,18.31V71.22a18.52,18.52,0,
                        0,1-18.73,18.31H19.76A18.52,18.52,0,0,1,1,71.22V19.34A18.53,18.53,0,0,
                        1,19.76,1H137.35m0-1H19.76A19.58,19.58,0,0,0,0,19.34V71.22A19.57,19.57,
                        0,0,0,19.76,90.56H137.35a19.58,19.58,0,0,0,19.76-19.34V19.34A19.58,19.58,
                        0,0,0,137.35,0Z"
                            style="fill:#fff"
                        />
                        <path
                            d="M19.76,85.46A14.42,14.42,0,0,1,5.19,71.22V19.34A14.43,
                        14.43,0,0,1,19.76,5.1H137.35a14.42,14.42,0,0,1,14.56,14.24V71.22a14.41,
                        14.41,0,0,1-14.56,14.24Z"
                            style="fill:#fff"
                        />
                    </g>
                </g>
        </svg>`;

const ServiceIcon = (props: Props): React.Node => {
    const { width, height } = props;
    return (
        Platform.OS === 'web' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 157.11 100.23">
                <title>device</title>
                <g id="Layer_2">
                    <g id="Layer_1-2">
                        <path
                            d="M31.7,99.71a2.55,2.55,0,1,1,0-5.09h93.7a2.55,2.55,0,1,1,0,5.09Z"
                            style={styles.first}
                        />
                        <path
                            d="M125.4,95.13a2,2,0,1,1,0,4.07H31.7a2,2,0,1,1,0-4.07h93.7m0-1H31.7a3.07,
                        3.07,0,1,0,0,6.13h93.7a3.07,3.07,0,1,0,0-6.13Z"
                            style={styles.fill_white}
                        />
                        <path
                            d="M19.76,90.05A19.06,19.06,0,0,1,.52,71.22V19.34A19.05,19.05,
                    0,0,1,19.76.52H137.35a19.05,19.05,0,0,1,19.24,18.82V71.22a19.06,
                    19.06,0,0,1-19.24,18.83Z"
                            style={styles.first}
                        />
                        <path
                            d="M137.35,1a18.53,18.53,0,0,1,18.73,18.31V71.22a18.52,18.52,0,
                    0,1-18.73,18.31H19.76A18.52,18.52,0,0,1,1,71.22V19.34A18.53,18.53,0,0,
                    1,19.76,1H137.35m0-1H19.76A19.58,19.58,0,0,0,0,19.34V71.22A19.57,19.57,
                    0,0,0,19.76,90.56H137.35a19.58,19.58,0,0,0,19.76-19.34V19.34A19.58,19.58,
                    0,0,0,137.35,0Z"
                            style={styles.fill_white}
                        />
                        <path
                            d="M19.76,85.46A14.42,14.42,0,0,1,5.19,71.22V19.34A14.43,
                    14.43,0,0,1,19.76,5.1H137.35a14.42,14.42,0,0,1,14.56,14.24V71.22a14.41,
                    14.41,0,0,1-14.56,14.24Z"
                            style={styles.fill_white}
                        />
                    </g>
                </g>
            </svg>
        ) : (
            <SvgXml xml={xml} />
        )
    );
};

ServiceIcon.defaultProps = {
    width: 120,
    height: undefined,
};

export default ServiceIcon;
